import React from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import getPrefixedPath from '~/utils/getPrefixedPath'

import s from './styles.module.scss'

type Props = {
  title?: string | JSX.Element
  imgPc: string
  imgSp: string
}

const Component: React.FC<Props> = ({ title, imgPc, imgSp }) => {
  return (
    <div className={s.kv}>
      {title && <h1>{title}</h1>}
      <figure>
        <picture>
          <source media="(min-width: 720px)" srcSet={getPrefixedPath(imgPc)} />
          <img src={getPrefixedPath(imgSp)} />
        </picture>
      </figure>
    </div>
  )
}

export default Component
